import api from './axios';

export const getPersonnelFiles = (userId) => api.get(`/users/${userId}/personnel-files`);
export const uploadPersonnelFile = (userId, formData) => api.post(`/users/${userId}/personnel-files`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' },
});
export const deletePersonnelFile = (id) => api.delete(`/personnel-files/${id}`);
export const getPersonnelFileTypes = () => api.get('/personnel-file-types');
export const createPersonnelFileType = (label) => api.post('/personnel-file-types', { label });
